import CaasApi from './caas-api';

export default config => {
	const HTTP = CaasApi(config);
	return {
		getNewsroomData: (pageSize, thema = "news", stage, lng = 'DE', translatedlng = 'DE', format = 'nr', prios = undefined, eventfilter = undefined) => {
			let sortstr = "{'date_sort':-1}";
			let categorystr = "{'category':'news'}";
			const andArray = [];
			if (thema && thema == 'events') {
				sortstr = "{'date_sort':1}";
				categorystr = "{'category':'events'}";

				//Ermittlung aktuelles UTC-Date zum Abgleich mit Eventdatum
				//let date_now = new Date().toJSON();
				let date_now = new Date();
				let date_day_now = String(date_now.getDate());
				if (date_day_now.length == 1) date_day_now = '0' + date_day_now;
				let date_month_now = String(date_now.getMonth() + 1);
				if (date_month_now.length == 1){
					date_month_now = '0' + date_month_now;
				}
				let date_year_now = date_now.getFullYear();
				let date_now_start = date_year_now + "-" + date_month_now + "-" + date_day_now + "T00:00:00Z";
				const date_end = {
					date_end: {
						$gte: {$date:`${date_now_start}`}
					}
				};
				andArray.push(date_end);

			} else if (thema && thema == 'news') {
				categorystr = "{'$or': [{'category':'news'},{'category':'video'},{'category':'socialmedia'},{'category':'gallery'}]}";
			}
			let uri = new String(
				`${
					config.document
				}?rep=hal&count=true&hal=f&pagesize=${pageSize}&page=1&sort=${sortstr}&filter=${categorystr}`
			);

			if (stage) {
				const categoryType = { categoryType: { $regex: `${stage}` } };
				andArray.push(categoryType);
			}

			if (prios) {
				const editorialType = { editorialType: { $regex: `${prios}` } };
				andArray.push(editorialType);
			}

			if (lng) {
				const fs_language = { fs_language: { $regex: `${lng}` } };
				andArray.push(fs_language);
			}

			if (translatedlng) {

				const fs_translatedlngs = { translatedLangs: { $regex: `${translatedlng}` } };
				andArray.push(fs_translatedlngs);
			}

			if (format) {

				const fs_format = { formats: { $regex: `${format}` } };
				andArray.push(fs_format);
			}

			if (andArray.length > 0) {
				let filter = {
					$and: andArray
				};
				uri = `${uri}&filter=${JSON.stringify(filter, `'`)}`;
			}

			if (eventfilter) {
				if (eventfilter.indexOf("=") == -1 && eventfilter.indexOf("$inc") == -1 && eventfilter.indexOf("$push") == -1 && eventfilter.indexOf("$pull") == -1){
					uri  = `${uri}&filter=${eventfilter}`;
				}
			}
			uri = encodeURI(uri);
			return HTTP.get(uri);
		},
		getNewsroomNextPage: function(pageLink) {
			return HTTP.get(pageLink);
		}
	};
};
